import { Injectable } from '@angular/core';
import { CodeEditorComponent } from './code-editor.component';

interface TextInsertable {
  insertTextToEditor(text: string): void;
}

@Injectable({
  providedIn: 'root',
})
export class CodeEditorService {
  private activeEditorInstance: CodeEditorComponent | null = null;
  private activeHtmlEditorInstance: TextInsertable | null = null;

  register(editor: CodeEditorComponent) {
    this.activeEditorInstance = editor;
  }

  unregister(): void {
    this.activeEditorInstance = null;
  }

  registerHtmlEditor(editor: TextInsertable) {
    this.activeHtmlEditorInstance = editor;
  }

  unregisterHtmlEditor(): void {
    this.activeHtmlEditorInstance = null;
  }

  insertTextIntoActiveEditor(text: string): void {
    if (this.activeHtmlEditorInstance) {
      this.activeHtmlEditorInstance.insertTextToEditor(text);
    } else if (this.activeEditorInstance) {
      this.activeEditorInstance.insertTextToEditor(text);
    }
  }
}
